<script setup lang="ts">
import CancelBookPage from '~/components/cancel-book/CancelBookPage.vue'

useSeoMeta({ robots: 'noindex, nofollow' })

definePageMeta({
  layout: 'simple'
})
</script>

<template>
  <CancelBookPage />
</template>
